import {ReactNode} from 'react';

export const declarationStatuses = [
    'DRAFT',
    'SUBMITTED',
    'REVIEW',
    'CONFIRMED',
    'REJECTED',
    'REJECTED_AUTOMATIC',
] as const;
export type DeclarationStatus = typeof declarationStatuses[number];

export enum DeclarationsAccessors {
    id = 'id',
    customsGdNumber = 'customsGdNumber',
    customsCode = 'customsCode',
    receiptedAt = 'receiptedAt',
    participantTin = 'participantTin',
    participantName = 'participantName',
    status = 'status',
}

export interface DeclarationsGridRawRow {
    id: string;
    customsGdNumber: string;
    customsCode: string;
    receiptedAt: string;
    participantTin: string;
    participantName: string;
    status: DeclarationStatus;
}

export interface DeclarationsGridFormattedRow {
    [DeclarationsAccessors.id]?: ReactNode;
    [DeclarationsAccessors.customsGdNumber]: string;
    [DeclarationsAccessors.customsCode]: string;
    [DeclarationsAccessors.receiptedAt]: ReactNode;
    [DeclarationsAccessors.participantTin]: string;
    [DeclarationsAccessors.participantName]: string;
    [DeclarationsAccessors.status]: ReactNode;
}

export interface DeclarationCodeRawRow {
    code: string;
    storageLocation: string;
    updatedAt: string;
    objectsNumber: number;
}

export interface DeclarationCodeFormattedRow {
    code: ReactNode;
    storageLocation: string;
    updatedAt: string;
    objectsNumber: number;
}

export interface DeclarationDetails<List = DeclarationCodeRawRow> {
    id: string;
    participantName: string;
    participantTin: string;
    storageLocation: string;
    receiptedAt: string;
    status: DeclarationStatus;
    gdNumber: string;
    customsMarkingCodeList: List[];
    customsId: number;
    legalIdentityId: number;
}

export interface DeclarationPaginationContent<C> {
    data: C[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
}
